module.exports = __webpack_public_path__ + "ab692e959d30682b6870fea538cc4bad.svg";